import {
  ContactRelationshipSchema,
  ContactSchema,
} from '@soniq/schema-connection'

export const CREATE_CONTACT_ID = 'create'

/**
 * UI-only marker used while editing connections to flag which contact
 * should receive invoices. For an existing contact this resolves to the
 * contact's id directly; for a brand-new contact the id is not known until
 * the contact is created, so the flag is resolved once ids are generated.
 * It is never persisted on the contact_relationship record.
 */
export interface BillingContactSelection {
  is_billing_contact?: boolean
}

export type NewContactRelationshipSchema = Pick<
  ContactRelationshipSchema,
  'relationship'
> &
  Pick<ContactSchema, 'name' | 'email'> &
  BillingContactSelection

export type ExistingContactRelationshipSchema = Pick<
  ContactRelationshipSchema,
  'relationship' | 'contact_id'
> &
  Partial<
    Omit<
      ContactRelationshipSchema,
      'relationship' | 'contact_id'
    >
  > &
  BillingContactSelection

export type NewContactOrExistingRelationship =
  | NewContactRelationshipSchema
  | ExistingContactRelationshipSchema

export interface ManageStudentAndTheirContactsSchema
  extends Pick<
    ContactSchema,
    'name' | 'email' | 'lesson_invoice_setting_id'
  > {
  contacts: Array<NewContactOrExistingRelationship>
}
